import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getTierCost } from '../lib/buy-flow';

import type { TransactionLines } from '@avalara/types/index';
import type { TierPlan } from '@avalara/types/index';
import type { BuyFlowState } from '@avalara/types/reducer-states';

export const initialState: BuyFlowState = {
  product: 'Avalara AvaTax',
  selectedTier: null,
  salestax: null,
  connectorTax: [],
  // The tier options to display for a user (derived from the supported connector(s),
  // on their account, and defaults to API if none found
  tiers: [],
  trialExtension: false,
  hideIframe: false,
};

const store = createSlice({
  name: 'buyFlow',
  initialState,
  reducers: {
    clearSelectedTier: (state) => {
      state.selectedTier = null;
    },
    receiveConnectorSalesTax: (state, action: PayloadAction<Array<TransactionLines>>) => {
      const connectorTax = action.payload.map((line) => ({ salestax: line.taxCalculated, amount: line.lineAmount }));
      state.connectorTax = connectorTax;
    },
    setSelectedTier: (state, action: PayloadAction<TierPlan>) => {
      state.selectedTier = action.payload;
      const cost = getTierCost(action.payload);
      state.salestax = state.connectorTax.find((conn) => conn.amount === cost)?.salestax || null;
    },
    setTrialExtension: (state) => {
      state.trialExtension = true;
    },
  },
});

export const { clearSelectedTier, receiveConnectorSalesTax, setSelectedTier, setTrialExtension } = store.actions;

export default store;
